/**
 * Class representing the HousingAffordability Period Selects.
 */
export default class HousingAffordabilityPeriodSelects {
    DataPageInstance;

    buttons;

    /**
     * Create a HousingAffordabilityPeriodSelects instance.
     * @param {Object} DataPageInstance - The instance of the Data Page.
     */
    constructor(DataPageInstance) {
        this.DataPageInstance = DataPageInstance;

        this.buttons = document.querySelectorAll('.js-period-button');

        //
        this.initializePeriodButtons();
    }

    /**
     * Initialize period buttons and add event listeners.
     */
    initializePeriodButtons() {
        let periodButtons = this.getPeriodButtons();

        if (periodButtons.length === 0) {
            throw Error(
                'There is no element on the page with the attribute "data-table-button="{type}".',
            );
        }

        periodButtons.forEach((button) => {
            button.addEventListener(
                'click',
                this.periodButtonEventHandler.bind(this),
            );
        });
    }

    /**
     * Handle the click event of a period button.
     * @param {Event} event - The click event.
     */
    periodButtonEventHandler(event) {
        event.preventDefault();
        let periodButtons = this.getPeriodButtons();
        const button = event.currentTarget;

        //
        periodButtons.forEach((el) => {
            el.classList.remove('active');
            el.classList.remove('a-btn--style-closed-type-01');
            el.classList.add('a-btn--style-open-type-01');
            el.classList.remove('pointer-events-none');
        });

        //
        button.classList.add('active');
        button.classList.add('a-btn--style-closed-type-01');
        button.classList.remove('a-btn--style-open-type-01');
        button.classList.add('pointer-events-none');

        //
        this.eventPeriodChange();
    }

    /**
     * Get the period buttons.
     * @returns {NodeList} - The list of period buttons.
     */
    getPeriodButtons() {
        return this.buttons;
    }

    /**
     * Get the active period.
     * @returns {string} - The active period ('annual' or 'monthly').
     */
    getActivePeriod() {
        let periodButtons = this.getPeriodButtons();

        for (const key in periodButtons) {
            const button = periodButtons[key];

            if (button.classList.contains('active')) {
                return button.getAttribute('data-table-button');
            }
        }

        return 'annual';
    }

    /**
     * Disable the period buttons.
     */
    disableSelects() {
        let periodButtons = this.getPeriodButtons();
        periodButtons.forEach((button) => {
            if (button.classList.contains('active')) {
                return;
            }
            button.classList.add(
                'pointer-events-none',
                'cursor-not-allowed',
                'opacity-50',
            );
        });
    }

    /**
     * Enable the period buttons.
     */
    enableSelects() {
        let periodButtons = this.getPeriodButtons();
        periodButtons.forEach((button) => {
            if (button.classList.contains('active')) {
                return;
            }
            button.classList.remove(
                'cursor-not-allowed',
                'pointer-events-none',
                'opacity-50',
            );
        });
    }

    /**
     * Trigger the 'gridPeriod.Change' event.
     */
    eventPeriodChange() {
        const event = new CustomEvent('gridPeriod.Change');

        document.dispatchEvent(event);
    }
}
